import React from "react";
import parse from "html-react-parser";
import { useTemplateStore } from "@/zustand/templateStore";
import s from "@/components/Testimonials/Testimonials.module.scss";
import cn from "@/utils/classNames.js";

const TestimonialsCard = ({ testimonial }) => {
  const { isMobile, cleanMobile, cleanDesktop } = useTemplateStore();
  const cleanCheck = (isMobile == false && cleanDesktop) || (isMobile == true && cleanMobile);
  const directCheck = window.cleanDirect && window?.affiliate?.includes("-direct");
  const enableCleanVersion = directCheck | cleanCheck;
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  return (
    <div data-testid="testimonials-card" className={cn(s.testimonials__box, isEnhancedContrast && s.enhancedContrast)}>
      <div className={s.testimonials__upperRow}>
        <div className={s["testimonials__upperRow--inside"]}>
          <div className={s.testimonials__stars}>
            <span>
              <img
                width="84"
                height="16"
                src={`${window.template_root}/templates/checkout-pages/V4/src/public/stars/${
                  enableCleanVersion ? "safe" : "full"
                }/star-${testimonial.checkout_v6_testimonial_stars}.svg`}
              ></img>
            </span>
          </div>
          <div
            data-testid="testimonials-card-name"
            className={cn(s.testimonials__name, isEnhancedContrast && s.enhancedContrast)}
          >
            {testimonial.checkout_v6_testimonial_author}
          </div>
        </div>
        <div className={s.testimonials__buyerLabel}>
          {window.post_template.checkout_v6_testimonials.tr_checkout_v6_testimonials_verifiedLabel}
        </div>
      </div>
      <div>
        <div
          data-testid="testimonials-card-title"
          className={cn(s.testimonials__title, isEnhancedContrast && s.enhancedContrast)}
        >
          {testimonial.tr_checkout_v6_testimonial_title}
        </div>
        <div
          data-testid="testimonials-card-description"
          className={cn(s.testimonials__text, isEnhancedContrast && s.enhancedContrast)}
        >
          {parse(testimonial.tr_checkout_v6_testimonial_description)}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsCard;
